import { render, staticRenderFns } from "./TopSectionsStaff.vue?vue&type=template&id=2c34993f&"
import script from "./TopSectionsStaff.vue?vue&type=script&lang=js&"
export * from "./TopSectionsStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports